import React from "react";
import { MFile, MInput, MLabel, ValidatedForm } from "components/forms";
import { dateHelper, payloadBuilder } from "libs";

export class IstanzaRiconoscimento extends ValidatedForm {
  emptyFields = {
    dataPresentazioneDomanda: "",
  };

  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  state = {
    ...this.emptyFields,
    document: 0,
    defaultValues: { ...this.emptyFields },
  };

  FIELDS_GROUP = [
    [
      {
        id: "dataPresentazioneDomanda",
        field: "dataPresentazioneDomanda",
        label: "Data di presentazione dell'istanza di riconoscimento",
        infoText: "(Data massima indicabile 24 dicembre 2024)",
        component: MInput,
        type: "date",
        className: "col-md-6",
      },
    ],
    [
      {
        field: "istanzaRiconoscimentoLabel",
        label: "Istanza di riconoscimento",
        component: MLabel,
        className: "col-md-12 pt-2 pb-0 mb-0",
      },
      {
        id: "istanzaRiconoscimentoFile",
        field: "document",
        component: MFile,
        value: this.props.enrollmentId,
        config: {
          endPoint: "/enrollment/attachment-file",
          fieldName: "document",
          maxFiles: 1,
          minFiles: 1,
          accept: ".pdf,.doc,.docx,.p7m,.xml",
          code: "istanzaRiconoscimento",
          mandatory: true,
        },
        className: "col-md-12",
      },
    ],
  ];

  validation = {
    dataPresentazioneDomanda: (value) => this.validateDataRiconoscimento(value),
  };

  ERROR_MESSAGES = {
    dataPresentazioneDomanda: "Inserire una data valida",
  };

  validateDataRiconoscimento = (value) => {
    if (value === "") {
      return false;
    }
    let regex = /^\d{4}-\d{2}-\d{2}$/;

    if (!value.match(regex)) {
      return false;
    }
    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return false;
    }
    const [year, month, day] = value.split("-").map(Number);

    if (month > 12) {
      return false;
    }
    if (day > 31) {
      return false;
    }

    const noFuture = dateHelper.noFuture(value);
    if (noFuture === false) {
      return false;
    }

    //data limite 24 dicembre 2024
    const maxDate = new Date("2024-12-24");
    if (date > maxDate) {
      this.setState({ validationError: "La data non può essere successiva al 24 dicembre 2024" });
      return false;
    }

    const currentYear = new Date().getFullYear();
    if (year < currentYear - 70 || year > currentYear) {
      return false;
    }

    return true;
  };

  componentDidMount() {
    const { defaultPayload, enrollmentId } = this.props;

    if (defaultPayload) {
      this.setState({
        ...defaultPayload,
        document: enrollmentId,
        defaultValues: {
          ...defaultPayload,
        },
      });
    } else {
      this.setState({
        document: enrollmentId,
        defaultValues: {
          ...this.state.defaultValues,
        },
      });
    }
  }

  onSubmit = () => {
    return this.checkValidation();
  };

  getPayload = () => {
    const payload = payloadBuilder(this.state);
    return payload;
  };

  render() {
    const { defaultValues, validationError } = this.state;
    const { code } = this.renderFields(this.FIELDS_GROUP, defaultValues, true);

    return (
      <>
        {code}
        {validationError && <div className="text-danger">{validationError}</div>}
      </>
    );
  }
}
